module.exports = __webpack_public_path__ + "img/online.30b47c5e.png";